import Head from 'next/head'
import TradlyFooter from '@/partials/TradlyFooter'

import BillingPanel from '@/components/settings/BillingPanel'

export default function Invoice() {
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Build and Launch a education marketplace like Coursera, Udemy
"
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly - Build and Launch a education marketplace like Coursera, Udemy
"
        />
        <title>Tradly - Build and Launch a education marketplace like Coursera, Udemy</title>
      </Head>
      <div className=" bg-[#f1f5f9] flex  flex-col min-h-screen overflow-hidden    ">
        <div className="flex-grow">
          <div className=" max-w-6xl mx-auto pt-20 mb-20 space-y-20 overflow-hidden sm:pt-32 sm:mb-32 sm:space-y-32 md:pt-40 md:mb-40 md:space-y-40 px-8 ">
            <div className="  shadow-lg rounded-sm mb-8">
              <BillingPanel />
            </div>
          </div>

          <TradlyFooter />
        </div>
      </div>
    </>
  )
}
